export const DISPLAY_TYPES = {
    numeric: 'numeric',
    string: 'string',
    translate: 'translate',
    date: 'date',
    incomeAccount: 'incomeAccount',
    action: 'action',
    expandAction: 'expandAction',
} as const;
